module.exports = __webpack_public_path__ + "img/loading.0de740bb.svg";